// src="https://www.google.com/maps?q=Mach%20Square%20Games%20Pvt.%20Ltd.&output=embed"
// src/pages/AboutPage.js
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function AboutPage() {
  const team = [
    { name: 'Sarfraz Saghir', title: 'Founder & CEO', img: 'https://randomuser.me/api/portraits/men/32.jpg' },
    { name: 'Hamza Ghafoor', title: 'Co-founder', img: 'https://randomuser.me/api/portraits/men/45.jpg' },
    { name: 'Fahad Rafiq', title: 'Co-founder', img: 'https://randomuser.me/api/portraits/men/68.jpg' }
  ];

  return (
    <div className="container py-5">
      {/* Hero Section */}
      <div className="bg-white text-black rounded-lg p-5 mb-5 shadow">
        <h1 className="display-4 text-primary fw-bold mb-3">Mach Square Games Pvt. Ltd.</h1>
        <p className="fs-5">
          Mach Square Games Pvt. Ltd. is a forward-thinking software studio
          building sleek, user-focused web applications on the MERN stack
          (MongoDB/Mongoose, Express, React, Node.js).
        </p>
        <p className="fs-5">
          Our Character Counter App showcases our documentation management
          suite with user registration, secure auth, document CRUD,
          personalized dashboards, and a dedicated admin panel for full
          control.
        </p>
      </div>

      {/* Leadership Team */}
      <div className="text-center mb-5">
        <h2 className="fw-bold mb-4">Our Leadership Team</h2>
        <div className="row justify-content-center g-4">
          {team.map((member, idx) => (
            <div key={idx} className="col-12 col-sm-6 col-md-4">
              <div className="card border-0 shadow-sm h-100 text-center">
                <img
                  src={member.img}
                  alt={member.name}
                  className="rounded-circle mt-4 mx-auto"
                  style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                />
                <div className="card-body">
                  <h5 className="card-title mb-1">{member.name}</h5>
                  <p className="text-muted mb-0">{member.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contact & Map */}
      <div className="row gy-4">
        <div className="col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <h3 className="fw-bold text-primary mb-3">Contact Information</h3>
              <ul className="list-unstyled fs-6">
                <li className="mb-2">
                  <i className="bi bi-telephone-fill text-primary me-2"></i>
                  <a href="tel:+923484266569" className="link-dark">
                    +92 348 4266569
                  </a>
                </li>
                <li>
                  <i className="bi bi-geo-alt-fill text-primary me-2"></i>
                  Mach Square Games Pvt. Ltd., Lahore, Pakistan
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="ratio ratio-16x9 shadow-sm rounded">
            <iframe
              title="Mach Square Games Location"
              src="https://www.google.com/maps?q=Mach%20Square%20Games%20Pvt.%20Ltd.&output=embed"
              allowFullScreen
              loading="lazy"
              style={{ border: 0 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
